import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_ENDPOINTS from "../../api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    try {
     

      const res = await axios.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
        email,
        password,
      });

     
      
      localStorage.setItem("adminToken", res.data.token);
      navigate("/admin/packages");
    } catch {
      alert("Invalid credentials");
    }
  };

  return (
    <div className="min-h-[90vh] flex items-center justify-center ">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        
        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-primeColor-500">
            Admin Panel
          </h2>
          <p className="text-sm text-slate-500 mt-1">
            Login to manage the system
          </p>
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-slate-600 mb-1">
            Email
          </label>
          <input
            type="email"
            placeholder="admin@example.com"
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border border-slate-300 rounded-lg
                       focus:outline-none focus:ring-2 focus:ring-blue-500
                       focus:border-blue-500 transition"
          />
        </div>

        {/* Password */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-slate-600 mb-1">
            Password
          </label>
          <input
            type="text"
            placeholder="••••••••"
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 border border-slate-300 rounded-lg
                       focus:outline-none focus:ring-2 focus:ring-blue-500
                       focus:border-blue-500 transition"
          />
        </div>

        {/* Button */}
        <button
          onClick={login}
          className="w-full py-2.5 rounded-lg bg-primeColor-500 text-white font-semibold
                     hover:bg-primeColor-600 active:scale-95 transition-all duration-200"
        >
          Login
        </button>

        {/* Footer */}
        <p className="text-center text-xs text-slate-400 mt-6">
          © {new Date().getFullYear()} Admin Dashboard
        </p>
      </div>
    </div>
  );
}
